module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": _vm.content.id
    }
  }, [(_vm.isReady) ? _c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-img"
  }, [_c('img', {
    attrs: {
      "src": _vm.entity.image ? _vm.entity.image.public_url : '',
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data"
  }, [_c('div', {
    staticClass: "menu-builder__item-data-row _id"
  }, [_c('b', [_vm._v("ID:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.id))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _title"
  }, [_c('b', [_vm._v("Title:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.title))])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-data-row _url"
  }, [_c('b', [_vm._v("Url:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.entity.url))])])]), _vm._v(" "), _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [(_vm.entity.hidden) ? _c('i', {
    staticClass: "fa fa-2x fa-eye-slash disabled",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning btn-open"
  }, [_vm._v("Open")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])])]) : _vm._e(), _vm._v(" "), (_vm.entity.children && _vm.entity.children.length) ? _c('ul', _vm._l((_vm.content.children), function(item) {
    return _c('menu-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6087e34a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/menu/MenuItem.vue
// module id = 923
// module chunks = 0